import React, { useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { kryzenstoreSchema } from "../../Schemas/Kryzen Store/kryzen_store_schema";
import { FcPaid } from "react-icons/fc";
import StepRoutes from "../../Routes/steps_routes";
import SimpleButton from "../../Components/layouts/simple_button";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

const AddEpgProduct = () => {
  const [hasVariants, setHasVariants] = useState(false);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedValues = {
        ...values,
        body_html: values.body_html,
      };

      // Default variant if no variants
      if (!hasVariants || values.variants.length === 0) {
        formattedValues.variants = [
          {
            title: values.title,
            price: values.price || 0,
            barcode: values.barcode || "",
            inventory_quantity: values.inventory_quantity || 0,
            requires_shipping: 1,
          },
        ];
      }

      const formData = new FormData();

      formData.append("product", JSON.stringify(formattedValues));

      // Main image
      if (values.image) {
        formData.append("image", values.image);
      }

      // Gallery images
      if (values.images?.length > 0) {
        values.images.forEach((file) => {
          formData.append("images", file);
        });
      }

      const res = await performRequest("POST", "/pmg/product/", formData);

      if (res.status === 201) {
        navigate(`/all-epg-product`);
        Toast("success", "Product created successfully!");
        resetForm();
      } else {
        Toast("error", "Error creating product!");
      }
    } catch (err) {
      console.error(err);
      Toast("error", "Server error while creating product!");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-xl py-4">
      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title mb-1">
              <FcPaid /> Add New EPG Product
            </h2>
            <h4 className="text-muted">
              <StepRoutes />
            </h4>
          </div>
        </div>
      </div>

      <div className="card my-4 p-4">
        <div className="card-header mb-5 py-3 fs-2 border d-flex justify-content-center">
          <h2>ADD EPG PRODUCT</h2>
        </div>

        <Formik
          initialValues={{
            title: "",
            body_html: "",
            variants: [],
            images: [],
            image: "",
            vendor: "Kryzen Biotech Pvt Ltd",
            product_type: "",
            barcode: "",
            category: "",
            handle: "",
            published_at: "",
            template_suffix: "",
            published_scope: "",
            tags: "",
          }}
          onSubmit={handleSubmit}
        >
          {({ values, touched, setFieldValue, isSubmitting, errors }) => {
            return (
              <Form>
                {/* Product Name */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">Product Name</label>
                  <div className="w-100 col">
                    <Field name="title" className="form-control" />
                    {touched.title && errors.title && (
                      <p className="text-danger">{errors.title}</p>
                    )}
                  </div>
                </div>

                {/* Description */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">
                    Product Description
                  </label>
                  <div className="w-100 col">
                    <Field
                      as="textarea"
                      name="body_html"
                      className="form-control"
                    />
                    {touched.body_html && errors.body_html && (
                      <p className="text-danger">{errors.body_html}</p>
                    )}
                  </div>
                  {console.log("values", values)}
                </div>

                {/* Main Image */}
                <div className="mb-3 row">
                  <label className="col-3 form-label fs-3">
                    Inventory Product Image
                  </label>
                  <div className="col">
                    <input
                      id="imageInvInput"
                      type="file"
                      className="form-control"
                      onChange={(e) =>
                        setFieldValue("image", e.target.files[0])
                      }
                    />
                  </div>
                </div>

                {/* Multiple Images */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">All Images</label>
                  <div className="w-100 col">
                    <input
                      type="file"
                      multiple
                      className="form-control"
                      //   onChange={(e) => {
                      //     const files = Array.from(e.target.files);

                      //     const readers = files.map(
                      //       (file) =>
                      //         new Promise((resolve) => {
                      //           const reader = new FileReader();
                      //           reader.onloadend = () =>
                      //             resolve({
                      //               src: reader.result,
                      //               alt: file.name,
                      //             });
                      //           reader.readAsDataURL(file);
                      //         })
                      //     );

                      //     Promise.all(readers).then((imgs) =>
                      //       setFieldValue("images", [...values.images, ...imgs])
                      //     );
                      //   }}
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        setFieldValue("images", [...values.images, ...files]);
                      }}
                    />

                    <div className="d-flex flex-wrap gap-3 mt-3 border">
                      {values.images.map((img, index) => (
                        <div key={index} className="border p-2">
                          <img
                            src={URL.createObjectURL(img)}
                            alt="preview"
                            style={{
                              width: 100,
                              height: 100,
                              objectFit: "cover",
                            }}
                          />

                          <br />

                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => {
                              const updated = values.images.filter(
                                (_, i) => i !== index
                              );
                              setFieldValue("images", updated);

                              if (fileInputRef.current) {
                                fileInputRef.current.value = "";
                              }
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Variant Toggle */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">
                    Has Multiple Variants
                  </label>

                  <div className="w-100 col">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ width: 25, height: 25 }}
                      checked={hasVariants}
                      onChange={(e) => setHasVariants(e.target.checked)}
                    />
                  </div>
                </div>

                {/* Variants */}
                {hasVariants && (
                  <FieldArray name="variants">
                    {({ remove, push }) => (
                      <div>
                        {values.variants.map((variant, index) => (
                          <div key={index} className="border rounded p-4 mb-3">
                            <div className="row g-3">
                              <div className="col-md-2">
                                <label>Variant Title</label>
                                <Field
                                  name={`variants.${index}.title`}
                                  className="form-control"
                                  placeholder="Enter Variant Title"
                                />
                              </div>
                              <div className="col-md-2">
                                <label>Price</label>
                                <Field
                                  name={`variants.${index}.price`}
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter Price"
                                />
                              </div>
                              <div className="col-md-2">
                                <label>Barcode</label>
                                <Field
                                  name={`variants.${index}.barcode`}
                                  className="form-control"
                                  placeholder="Enter Barcode"
                                />
                              </div>
                              <div className="col-md-2">
                                <label>Quantity</label>
                                <Field
                                  name={`variants.${index}.inventory_quantity`}
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter Quantity"
                                />
                              </div>

                              <div className="col-md-2 position-relative">
                                <label>Unit</label>

                                <Field
                                  as="select"
                                  name={`variants.${index}.unit`}
                                  className="form-control pr-4"
                                >
                                  <option value="">select</option>
                                  <option value="pcs">pcs</option>
                                  <option value="kg">kg</option>
                                  <option value="g">g</option>
                                  <option value="ltr">ltr</option>
                                  <option value="nos">nos</option>
                                  <option value="ml">ml</option>
                                </Field>

                                {/* Arrow Icon */}
                                <FaChevronDown
                                  style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "38px",
                                    fontSize: "12px",
                                    color: "#666",
                                    pointerEvents: "none",
                                  }}
                                />
                              </div>
                              <div className="col-md-2">
                                <div className="text-end mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                        <button
                          type="button"
                          className="btn btn-outline-success mb-3"
                          onClick={() =>
                            push({
                              title: "",
                              price: "",
                              barcode: "",
                              inventory_quantity: "",
                              unit: "",
                            })
                          }
                        >
                          + Add Variant
                        </button>
                      </div>
                    )}
                  </FieldArray>
                )}

                {/* Submit */}
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <button
                      type="submit"
                      className="btn btn-primary mx-1 mt-2"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save Product"}
                    </button>

                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddEpgProduct;
